import script from "./errorMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./errorMessage.vue?vue&type=script&setup=true&lang=ts"

import "./errorMessage.vue?vue&type=style&index=0&id=3b0a4378&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0a4378"]])

export default __exports__